import React, { useEffect, useState, forwardRef, useRef } from "react";
import moment from "moment-timezone";
import {
  onChangeHeightOfTextArea,
  onChangeInput,
  radioButtonWidget,
  textInputWidget,
  textWidget,
} from "../../utils/general";
// import "../../styles/signature.css";
import RegexParser from "regex-parser";
import { PencilIcon } from "@heroicons/react/24/outline";

const changeDateToMomentFormat = (format) => {
  switch (format) {
    case "mm/dd/yyyy":
      return "L";
    case "dd-MM-yyyy":
      return "DD-MM-YYYY";
    case "dd/MM/yyyy":
      return "DD/MM/YYYY";
    case "yyyy-MM-dd":
      return "YYYY-MM-DD";
    default:
      return "L";
  }
};

const parseDateFromResponse = (dateStr, format) => {
  if (!dateStr) return new Date();
  const momentFormat = changeDateToMomentFormat(format || "mm/dd/yyyy");
  const parsed = moment.tz(dateStr, momentFormat, "GMT");
  return parsed.isValid() ? new Date(parsed.toISOString()) : new Date();
};

// Helper function to capitalize first letter
const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return `${
    string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }`.toUpperCase();
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const textWidgetCls =
  "w-full h-full md:min-w-full md:min-h-full z-[999] pl-1 text-[12px] border-[0px] border-[#007bff] overflow-hidden resize-none outline-none text-base-content item-center whitespace-pre-wrap";
const selectWidgetCls =
  "w-full h-full absolute left-0 top-0 border-[0px] border-[#007bff] focus:outline-none text-base-content";
const widgetCls =
  "select-none-cls overflow-hidden w-full h-full text-black flex flex-col justify-center items-center";
function PlaceholderType(props) {
  //   const { t } = useTranslation();
  const type = props?.pos?.type;
  const widgetTypeTranslation = props?.pos?.type; //t(`widgets-name.${props?.pos?.type}`);
  const [selectOption, setSelectOption] = useState("");
  const [validatePlaceholder, setValidatePlaceholder] = useState("");
  const inputRef = useRef(null);
  const [textValue, setTextValue] = useState();
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const [hint, setHint] = useState("");

  const fontSize = props.calculateFont(props.pos.options?.fontSize);
  const fontColor = props.pos.options?.fontColor || "black";
  const isAssignedToCurrentSigner =
    !props.isNeedSign || props.data?.signerObjId === props.signerObjId;
  const isWidgetReadOnlyForSigner =
    props.isNeedSign &&
    (props.pos.options?.isReadOnly || !isAssignedToCurrentSigner);
  const textWidgetStyle = {
    fontSize: fontSize,
    color: fontColor,
    overflow: "hidden",
    textAlign: "start",
    width: "100%",
    display: "flex",
    height: "100%",
  };
  const validateExpression = (regexValidation) => {
    if (textValue && regexValidation) {
      let regexObject = regexValidation;
      if (props.pos?.options?.validation?.type === "regex") {
        regexObject = RegexParser(regexValidation);
      }
      // new RegExp(regexValidation);
      let isValidate = regexObject.test(textValue);
      if (!isValidate) {
        props?.setValidateAlert(true);
        inputRef.current.focus();
      }
    }
  };

  const handleInputBlur = () => {
    const validateType = props.pos?.options?.validation?.type;
    let regexValidation;
    if (validateType && validateType !== "text") {
      switch (validateType) {
        case "email":
          regexValidation = emailRegex;
          validateExpression(regexValidation);
          break;
        case "number":
          regexValidation = /^[0-9\s]*$/;
          validateExpression(regexValidation);
          break;
        default:
          regexValidation = props.pos?.options?.validation?.pattern || "";
          validateExpression(regexValidation);
      }
    }
  };

  const handleTextValid = (e) => {
    const textInput = e.target.value;
    setTextValue(textInput);
  };
  function checkRegularExpress(validateType) {
    switch (validateType) {
      case "email":
        setValidatePlaceholder("demo@gmail.com");
        break;
      case "number":
        setValidatePlaceholder("12345");
        break;
      case "text":
        setValidatePlaceholder("please enter text");
        break;
      default:
        setValidatePlaceholder("please enter value");
    }
  }

  useEffect(() => {
    if (type && type === "checkbox" && props.isNeedSign) {
      const isDefaultValue = props.pos.options?.defaultValue;
      if (isDefaultValue) {
        setSelectedCheckbox(isDefaultValue);
      }
    } else if (props.pos?.options?.hint) {
      setValidatePlaceholder(props.pos?.options.hint);
    } else if (props.pos?.options?.validation?.type) {
      checkRegularExpress(props.pos?.options?.validation?.type);
    }
    setTextValue(
      props.pos?.options?.response
        ? props.pos?.options?.response
        : props.pos?.options?.defaultValue
          ? props.pos?.options?.defaultValue
          : "",
    );
    setSelectOption(
      props.pos?.options?.response
        ? props.pos?.options?.response
        : props.pos?.options?.defaultValue
          ? props.pos?.options?.defaultValue
          : "",
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pos?.options?.response, props.pos?.options?.defaultValue]);

  useEffect(() => {
    if (
      ["name", "email", "job title", "company"].includes(props.pos?.type) &&
      props.isNeedSign &&
      props.data?.signerObjId === props?.signerObjId
    ) {
      const defaultData = props.pos?.options?.defaultValue;
      if (defaultData) {
        setTextValue(defaultData);
      }
      if (props.pos?.options?.hint) {
        setHint(props.pos?.options.hint);
      } else {
        setHint(props.pos?.type);
      }
    } else if ([textInputWidget].includes(props.pos?.type)) {
      const defaultData = props.pos?.options?.defaultValue;
      const name = props.pos?.options?.name;
      if (defaultData) {
        setTextValue(defaultData);
      }
      // Note: name is now used as placeholder, not as value
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pos?.options?.defaultValue]);

  useEffect(() => {
    if (
      ["name", "email", "job title", "company"].includes(type) &&
      props.isNeedSign &&
      props.data?.signerObjId === props.signerObjId
    ) {
      const isDefault = true;
      const senderUser = localStorage.getItem(`Extand_Class`);
      const jsonSender = JSON.parse(senderUser);
      onChangeInput(
        jsonSender && jsonSender[0],
        null,
        props.xyPosition,
        null,
        props.setXyPosition,
        props.data.Id,
        isDefault,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);
  //function for show checked checkbox
  const selectCheckbox = (ind) => {
    const res = props.pos.options?.response;
    const defaultCheck = props.pos.options?.defaultValue;
    if (res && res?.length > 0) {
      const isSelectIndex = res.indexOf(ind);
      if (isSelectIndex > -1) {
        return true;
      } else {
        return false;
      }
      // }
    } else if (defaultCheck) {
      const isSelectIndex = defaultCheck.indexOf(ind);
      if (isSelectIndex > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleRadioCheck = (data) => {
    const defaultData = props.pos.options?.defaultValue;
    if (textValue === data) {
      return true;
    } else if (defaultData === data) {
      return true;
    } else {
      return false;
    }
  };

  //function for set checked and unchecked value of checkbox
  const handleCheckboxValue = (isChecked, ind) => {
    let updateSelectedCheckbox = [],
      checkedList;
    let isDefaultValue, isDefaultEmpty;
    if (type === "checkbox") {
      updateSelectedCheckbox = selectedCheckbox ? selectedCheckbox : [];

      if (isChecked) {
        updateSelectedCheckbox.push(ind);
        setSelectedCheckbox(updateSelectedCheckbox);
      } else {
        checkedList = selectedCheckbox.filter((data) => data !== ind);
        setSelectedCheckbox(checkedList);
      }
      if (props.isNeedSign) {
        isDefaultValue = props.pos.options?.defaultValue;
      }
      if (isDefaultValue && isDefaultValue.length > 0) {
        isDefaultEmpty = true;
      }
      onChangeInput(
        checkedList ? checkedList : updateSelectedCheckbox,
        props.pos.key,
        props.xyPosition,
        props.index,
        props.setXyPosition,
        props.data && props.data.Id,
        false,
        null,
        isDefaultEmpty,
      );
    }
  };

  //function to handle select radio widget and set value seletced by user
  const handleCheckRadio = (isChecked, data) => {
    let isDefaultValue,
      isDefaultEmpty,
      isRadio = true;
    if (props.isNeedSign) {
      isDefaultValue = props.pos.options?.defaultValue;
    }
    if (isDefaultValue) {
      isDefaultEmpty = true;
    }
    if (isChecked) {
      setTextValue(data);
    } else {
      setTextValue("");
    }
    onChangeInput(
      data,
      props.pos.key,
      props.xyPosition,
      props.index,
      props.setXyPosition,
      props.data && props.data.Id,
      false,
      null,
      isDefaultEmpty,
      isRadio,
    );
  };
  //function to get date format with proper fallback
  const getDateFormat = () => {
    if (props.selectDate && props.selectDate.format) {
      return props.selectDate.format.toUpperCase();
    } else if (props.pos?.options?.validation?.format) {
      return props.pos.options.validation.format.toUpperCase();
    } else {
      return "MM/DD/YYYY";
    }
  };

  //function to format date for display
  const formatDateForDisplay = (date) => {
    if (!date) return "";

    const dateFormat = getDateFormat();

    // Simple date formatting - you might want to use a library like date-fns for more robust formatting
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();

    return dateFormat
      .replace("MM", month)
      .replace("dd", day)
      .replace("yyyy", year);
  };
  const getDefaultFormat = (dateFormat) => dateFormat || "mm/dd/yyyy";

  // dateInputType: "signature" = auto-fill with today on click; "free" = open date picker for user to select
  const dateInputType = props.pos?.options?.dateInputType || "free";

  const handleDateClick = () => {
    if (
      !props.isPlaceholder &&
      (props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId))
    ) {
      if (dateInputType === "free" && props.openDateModal) {
        // Free input: open date picker modal for user to select any date
        const currentDate = props.pos?.options?.response
          ? parseDateFromResponse(
              props.pos.options.response,
              props.pos?.options?.validation?.format,
            )
          : new Date();
        props.openDateModal(
          currentDate,
          (newDate) => {
            const formattedDate = formatDateForDisplay(newDate);
            setTextValue(formattedDate);
            if (props.setStartDate) props.setStartDate(newDate);
            props.handleSaveDate(
              {
                date: newDate,
                format: getDefaultFormat(
                  props.pos?.options?.validation?.format,
                ),
              },
              true,
            );
          },
          getDefaultFormat(props.pos?.options?.validation?.format),
          props.calculateFont?.(props.pos?.options?.fontSize) || "14px",
          props.pos?.options?.fontColor || "black",
          true, // allowPastDates for free input
        );
      } else {
        // Signature date: set today's date only if not already set
        if (!textValue) {
          const today = new Date();
          const formattedDate = formatDateForDisplay(today);
          setTextValue(formattedDate);

          if (props.setStartDate) {
            props.setStartDate(today);
          }

          props.handleSaveDate(
            {
              date: formattedDate,
              format: getDefaultFormat(props.pos?.options?.validation?.format),
            },
            true,
          );
        }
      }
    }
  };

  //handle height on enter press in text area
  const handleEnterPress = (e) => {
    const height = 18;
    if (e.key === "Enter") {
      //function to save height of text area
      onChangeHeightOfTextArea(
        height,
        props.pos.type,
        props.pos.key,
        props.xyPosition,
        props.index,
        props.setXyPosition,
        props.data && props.data?.Id,
      );
    }
  };
  switch (type) {
    case "signature":
      return props.pos.SignUrl ? (
        <img
          alt="signature"
          draggable="false"
          src={props.pos.SignUrl}
          className="w-full h-full select-none-cls "
        />
      ) : (
        <div className={widgetCls}>
          <PencilIcon className="w-4 h-4" />
          <span className="text-xs font-medium">Signature</span>
          {/* {props.pos.type && (
            <div
              style={{
                fontSize: props.pos
                  ? props.calculateFontsize(props.pos)
                  : "11px",
              }}
              className="font-medium"
            >
              {capitalizeFirstLetter(
                props.isNeedSign
                  ? props.pos?.options?.hint || widgetTypeTranslation
                  : widgetTypeTranslation,
              )}
            </div>
          )} */}
        </div>
      );
    case "stamp":
      return props.pos.SignUrl ? (
        <img
          alt="stamp"
          draggable="false"
          src={props.pos.SignUrl}
          className="w-full h-full select-none-cls"
        />
      ) : (
        <div className={widgetCls}>
          {props.pos.type && (
            <div
              style={{
                fontSize: props.pos
                  ? props.calculateFontsize(props.pos)
                  : "11px",
              }}
              className="font-medium"
            >
              {props.isNeedSign
                ? props.pos?.options?.hint || widgetTypeTranslation
                : widgetTypeTranslation}
            </div>
          )}
        </div>
      );
    case "image":
      return props.pos.SignUrl ? (
        <img
          alt=""
          draggable="false"
          src={props.pos.SignUrl}
          className="w-full h-full select-none-cls object-cover"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div className={widgetCls}>
          {props.pos.type && (
            <div
              style={{
                fontSize: props.pos
                  ? props.calculateFontsize(props.pos)
                  : "11px",
              }}
              className="font-medium"
            >
              {capitalizeFirstLetter(
                props.isNeedSign
                  ? props.pos?.options?.hint || widgetTypeTranslation
                  : widgetTypeTranslation,
              )}
            </div>
          )}
        </div>
      );
    case "checkbox":
      return (
        <div style={{ zIndex: props.isSignYourself && "99" }}>
          {props.pos.options?.values?.map((data, ind) => {
            return (
              <div
                key={ind}
                className="select-none-cls flex items-center text-center gap-0.5"
              >
                <input
                  id={`checkbox-${props.pos.key + ind}`}
                  style={{
                    width: fontSize,
                    height: fontSize,
                    borderRadius: "6px",
                  }}
                  className={`${
                    ind === 0 ? "mt-0" : "mt-[5px]"
                  } flex justify-start op-checkbox `}
                  onBlur={handleInputBlur}
                  disabled={
                    props.isNeedSign &&
                    (props.pos.options?.isReadOnly ||
                      props.data?.signerObjId !== props.signerObjId)
                  }
                  type="checkbox"
                  checked={selectCheckbox(ind)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      if (!props.isPlaceholder) {
                        const maxRequired =
                          props.pos.options?.validation?.maxRequiredCount;
                        const maxCountInt =
                          maxRequired && parseInt(maxRequired);

                        if (maxCountInt > 0) {
                          if (
                            selectedCheckbox &&
                            selectedCheckbox?.length <= maxCountInt - 1
                          ) {
                            handleCheckboxValue(e.target.checked, ind);
                          }
                        } else {
                          handleCheckboxValue(e.target.checked, ind);
                        }
                      }
                    } else {
                      handleCheckboxValue(e.target.checked, ind);
                    }
                  }}
                />
                {!props.pos.options?.isHideLabel && (
                  <label
                    htmlFor={`checkbox-${props.pos.key + ind}`}
                    style={{ fontSize: fontSize, color: fontColor }}
                    className="text-xs mb-0 text-center"
                  >
                    {data}
                  </label>
                )}
              </div>
            );
          })}
        </div>
      );
    case textInputWidget:
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <textarea
          ref={inputRef}
          placeholder={(
            props.pos?.options?.name || validatePlaceholder
          )?.toUpperCase()}
          rows={1}
          onKeyDown={handleEnterPress}
          value={textValue}
          onBlur={handleInputBlur}
          onChange={(e) => {
            setTextValue(e.target.value);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          {...(props.pos.options?.maxLength && {
            maxLength: props.pos.options.maxLength,
          })}
          {...(props.pos.options?.minLength && {
            minLength: props.pos.options.minLength,
          })}
          className={`${textWidgetCls} placeholder:text-black ${
            isWidgetReadOnlyForSigner
              ? "bg-black/68 select-none placeholder:text-white"
              : ""
          }`}
          style={{
            fontSize: fontSize,
            color: fontColor,
            background: isWidgetReadOnlyForSigner ? undefined : "transparent",
          }}
          disabled={isWidgetReadOnlyForSigner}
          cols="50"
        />
      ) : (
        <div style={textWidgetStyle} className="select-none-cls">
          <span style={{ textTransform: textValue ? "none" : "uppercase" }}>
            {props.pos?.options?.name || textValue || widgetTypeTranslation}
          </span>
        </div>
      );
    case "dropdown":
      return props.data?.signerObjId === props.signerObjId ? (
        <select
          style={{ fontSize: fontSize, color: fontColor }}
          className={`${
            props.isNeedSign &&
            (props.pos.options?.isReadOnly ||
              props.data?.signerObjId !== props.signerObjId)
              ? " disabled:bg-inherit select-none "
              : `${selectWidgetCls} text-[12px] bg-inherit`
          }`}
          id="myDropdown"
          value={selectOption}
          onChange={(e) => {
            setSelectOption(e.target.value);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          disabled={
            props.isNeedSign &&
            (props.pos.options?.isReadOnly ||
              props.data?.signerObjId !== props.signerObjId)
          }
        >
          {/* Default/Title option */}
          <option
            style={{ fontSize: fontSize, color: fontColor }}
            value=""
            disabled
            hidden
          >
            {props?.pos?.options?.name}
          </option>

          {props.pos?.options?.values?.map((data, ind) => {
            return (
              <option
                style={{ fontSize: fontSize, color: fontColor }}
                key={ind}
                value={data}
              >
                {data}
              </option>
            );
          })}
        </select>
      ) : (
        <div
          style={textWidgetStyle}
          className="select-none-cls flex justify-between items-center"
        >
          {props.pos?.options?.name
            ? props.pos.options.name
            : widgetTypeTranslation}
          <i className="fa-light fa-circle-chevron-down mr-1 "></i>
        </div>
      );
    case "initials":
      return props.pos.SignUrl ? (
        <img
          alt="initials"
          draggable="false"
          src={props.pos.SignUrl}
          className="w-full h-full select-none-cls"
        />
      ) : (
        <div className={widgetCls}>
          <PencilIcon className="w-4 h-4" />
          <span className="text-xs font-medium">Initials</span>
          {/* {props.pos.type && (
            <div
              style={{
                fontSize: props.pos
                  ? props.calculateFontsize(props.pos)
                  : "11px",
              }}
              className="font-medium text-center"
            >
              {capitalizeFirstLetter(
                props.isNeedSign
                  ? props.pos?.options?.hint || widgetTypeTranslation
                  : widgetTypeTranslation,
              )}
            </div>
          )} */}
        </div>
      );
    case "name":
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <textarea
          ref={inputRef}
          placeholder={capitalizeFirstLetter(hint || widgetTypeTranslation)}
          rows={1}
          onKeyDown={handleEnterPress}
          value={textValue}
          onChange={(e) => {
            const isDefault = false;
            handleTextValid(e);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              isDefault,
            );
          }}
          className={`${textWidgetCls} placeholder:text-black ${
            isWidgetReadOnlyForSigner
              ? "bg-black/68 select-none placeholder:text-white"
              : ""
          }`}
          style={{
            fontSize: fontSize,
            color: fontColor,
            background: isWidgetReadOnlyForSigner ? undefined : "transparent",
          }}
          cols="50"
        />
      ) : (
        <div className="flex h-full select-none-cls" style={textWidgetStyle}>
          <span>
            {textValue || capitalizeFirstLetter(widgetTypeTranslation)}
          </span>
        </div>
      );
    case "company":
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <textarea
          ref={inputRef}
          placeholder={hint || widgetTypeTranslation}
          rows={1}
          onKeyDown={handleEnterPress}
          value={textValue}
          onChange={(e) => {
            handleTextValid(e);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          className={textWidgetCls}
          style={{ fontSize: fontSize, color: fontColor }}
          cols="50"
        />
      ) : (
        <div style={textWidgetStyle} className="select-none-cls">
          <span>{widgetTypeTranslation}</span>
        </div>
      );
    case "job title":
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <textarea
          ref={inputRef}
          placeholder={hint || widgetTypeTranslation}
          rows={1}
          onKeyDown={handleEnterPress}
          value={textValue}
          onChange={(e) => {
            handleTextValid(e);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          className={textWidgetCls}
          style={{ fontSize: fontSize, color: fontColor }}
          cols="50"
        />
      ) : (
        <div style={textWidgetStyle} className="select-none-cls">
          <span>{widgetTypeTranslation}</span>
        </div>
      );
    case "date":
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <>
          <div
            // className={textWidgetCls}
            style={{ ...textWidgetStyle, fontSize: fontSize, color: fontColor }}
            // className={`${
            //   props.isSignYourself ||
            //   (props.isSelfSign &&
            //     props.data?.signerObjId === props.signerObjId) ||
            //   (props.isNeedSign &&
            //     props.data?.signerObjId === props.signerObjId)
            //     ? "cursor-pointer border border-gray-300 rounded px-2 py-1"
            //     : "select-none-cls"
            // } overflow-hidden`}
            onClick={handleDateClick}
            // onClick={() => {
            //   // Set today's date when clicked during signing
            //   const today = new Date();
            //   const formattedDate = formatDateForDisplay(today);
            //   setTextValue(formattedDate);
            //   // Set startDate for the parent component
            //   if (props.setStartDate) {
            //     props.setStartDate(today);
            //   }

            //   onChangeInput(
            //     formattedDate,
            //     props.pos.key,
            //     props.xyPosition,
            //     props.index,
            //     props.setXyPosition,
            //     props.data && props.data?.Id,
            //     false
            //   );
            // }}
          >
            <span>{textValue || getDateFormat()}</span>
          </div>
        </>
      ) : (
        <div
          style={textWidgetStyle}
          className="select-none-cls overflow-hidden"
        >
          <span>{textValue || getDateFormat()}</span>
        </div>
      );
    case "email":
      return props.isSignYourself ||
        (props.isSelfSign && props.data?.signerObjId === props.signerObjId) ||
        (props.isNeedSign && props.data?.signerObjId === props.signerObjId) ? (
        <textarea
          ref={inputRef}
          placeholder={hint || widgetTypeTranslation}
          rows={1}
          onKeyDown={(e) => {
            // Prevent new line on Enter key press
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          value={textValue}
          onBlur={handleInputBlur}
          onChange={(e) => {
            handleTextValid(e);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          className={textWidgetCls}
          style={{
            fontSize: fontSize,
            color: fontColor,
            fontFamily: "Arial, sans-serif",
          }}
          cols="1"
        />
      ) : (
        <div style={textWidgetStyle} className="select-none-cls">
          <span>{capitalizeFirstLetter(widgetTypeTranslation)}</span>
        </div>
      );
    case radioButtonWidget:
      return (
        <div>
          {props.pos.options?.values.map((data, ind) => {
            return (
              <div
                key={ind}
                className="select-none-cls flex items-center text-center gap-0.5"
              >
                <input
                  id={`radio-${props.pos.key + ind}`}
                  style={{
                    width: fontSize,
                    height: fontSize,
                    marginTop: ind > 0 ? "10px" : "0px",
                  }}
                  className={`flex justify-center op-radio`}
                  type="radio"
                  disabled={
                    props.isNeedSign &&
                    (props.pos.options?.isReadOnly ||
                      props.data?.signerObjId !== props.signerObjId)
                  }
                  checked={handleRadioCheck(data)}
                  onChange={(e) => {
                    if (!props.isPlaceholder) {
                      handleCheckRadio(e.target.checked, data);
                    }
                  }}
                />
                {!props.pos.options?.isHideLabel && (
                  <label
                    htmlFor={`radio-${props.pos.key + ind}`}
                    style={{ fontSize: fontSize, color: fontColor }}
                    className="text-xs mb-0"
                  >
                    {data}
                  </label>
                )}
              </div>
            );
          })}
        </div>
      );
    case textWidget:
      return (
        <textarea
          placeholder={"Text"}
          rows={1}
          onKeyDown={handleEnterPress}
          value={textValue}
          onBlur={handleInputBlur}
          onChange={(e) => {
            setTextValue(e.target.value);
            onChangeInput(
              e.target.value,
              props.pos.key,
              props.xyPosition,
              props.index,
              props.setXyPosition,
              props.data && props.data?.Id,
              false,
            );
          }}
          className={textWidgetCls}
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: fontSize,
            color: fontColor,
          }}
          cols="50"
        />
      );
    default:
      return props.pos.SignUrl ? (
        <div className="pointer-events-none">
          <img
            alt="image"
            draggable="false"
            src={props.pos.SignUrl}
            className="w-full h-full "
          />
        </div>
      ) : (
        <div className={widgetCls}>
          {props.pos.isStamp ? <div>stamp</div> : <div>signature</div>}
          {props.pos.type && (
            <div
              style={{
                fontSize: props.pos
                  ? props.calculateFontsize(props.pos)
                  : "11px",
              }}
              className="font-medium"
            >
              {props.isNeedSign
                ? props.pos?.options?.hint || widgetTypeTranslation
                : widgetTypeTranslation}
            </div>
          )}
        </div>
      );
  }
}

export default PlaceholderType;
